import { getRequest } from "../request";
import { BASVURU_STATE_CONNECTOR } from "../constants/requestUrls";

export const BasvuruStateConnector = (basvuruId) => {
    return getRequest({url:BASVURU_STATE_CONNECTOR + '?basvuruId=' + basvuruId});
}
